import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContextProvider } from './context';
import AppGuard from './components/guard';
import ProtectedRoute from './components/guard/ProtectedRoute';
import AuthRoute from './components/guard/AuthRoute';
import HomePage from './pages/Home';
import LoadingPage from './pages/Loading';
import NotFoundPage from './pages/NotFound';
import SignInPage from './pages/SignIn';
import SignUpPage from './pages/SignUp';
import AuthCallbackPage from './pages/AuthCallback';

function App() {
  return (
    <AppContextProvider>
      <AppGuard>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/signin"
            element={
              <AuthRoute>
                <SignInPage />
              </AuthRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <AuthRoute>
                <SignUpPage />
              </AuthRoute>
            }
          />
          <Route path="/callback" element={<AuthCallbackPage />} />
          <Route path="/loading" element={<LoadingPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </AppGuard>
    </AppContextProvider>
  );
}

export default App;
